<template>
  <AuthLayout>
    <div class="nftmax-wc__form">
      <div class="nftmax-wc__form-inner">
        <div class="nftmax-wc__heading">
          <h3
            class="nftmax-wc__form-title nftmax-wc__form-title__one"
            style="background-image: url('../../assets/img/heading-vector.png')"
          >
            Log In
          </h3>
        </div>
        <!-- Sign in Form -->
        <form class="nftmax-wc__form-main" action="/" method="post">
          <div class="form-group">
            <label class="nftmax-wc__form-label">Email Address</label>
            <div class="form-group__input">
              <el-input v-model="userName" placeholder=""></el-input>
            </div>
          </div>
          <div class="form-group">
            <label class="nftmax-wc__form-label">Password</label>
            <div class="form-group__input">
              <el-input
                v-model="password"
                placeholder=""
                type="password"
                show-password
              ></el-input>
            </div>
          </div>
          <div class="form-group" style="text-align: right">
            <div
              id="recaptcha-main"
              class="g-recaptcha"
              data-sitekey="6LfCDqYoAAAAAMp6KRCONh-m2ruSgU6eXJJe2_lk"
              style="display: inline-block"
            ></div>
          </div>
          <div class="form-group">
            <div class="form-group">
              <div class="nftmax-wc__check-inline">
                <div class="nftmax-wc__forgot">
                  <router-link
                    :to="{
                      name: 'ForgotPassword',
                      params: { previousPageName: 'Login' },
                    }"
                    class="forgot-pass"
                    >Forgot Password?</router-link
                  >
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="nftmax-wc__check-inline">
                <div class="nftmax-wc__forgot">
                  New to Lavita?
                  <router-link
                    to="/signup"
                    class="forgot-pass"
                    style="color: #34e393"
                    >Sign Up</router-link
                  >
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="nftmax-wc__button">
                <button class="ntfmax-wc__btn" type="button" @click="login">
                  Log In
                </button>
                <!-- Google OAuth2 登录按钮 - 跳转到Google页面 -->
                <button
                  class="ntfmax-wc__btn ntfmax-wc__btn-google"
                  type="button"
                  @click="googleLogin"
                >
                  <div class="ntfmax-wc__btn-icon">
                    <img src="../../assets/img/google-logo.png" alt="logo" />
                  </div>
                  Log In with Google
                </button>
              </div>
            </div>
          </div>
        </form>
        <!-- End Sign in Form -->
      </div>
    </div>
  </AuthLayout>
</template>

<script>
import AuthLayout from "@/components/Auth/AuthLayout";
import api from "../../http/api";

export default {
  components: { AuthLayout },
  data() {
    return {
      userName: "",
      password: "",
      imageCode: "",
      token: "",
      // Google OAuth2 配置
      googleClientId:
        "624634189004-j5726tt7a5bidnrt49qq0nr0bbaeqln7.apps.googleusercontent.com",
      googleRedirectUri: "https://platform.lavita.ai/login", // 你的回调地址
      googleScope: "openid email profile", // 请求的权限范围
    };
  },
  computed: {
    isMobile() {
      const userAgent = navigator.userAgent;
      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        );
      return isMobile;
    },
  },
  async mounted() {
    this.checkIfMobile();
    this.$nextTick(function () {
      window.grecaptcha.render("recaptcha-main");
    });

    // 检查是否是从Google回调返回的
    this.handleGoogleCallback();
  },
  methods: {
    // 获取并保存订阅信息
    async fetchSubscriptionInfo(userId) {
      try {
        const res = await api.getSubscriptionInfo(String(userId));
        this.$store.commit("saveSubscriptionInfo", res.data.data);
      } catch (e) {
        console.warn("[Subscription] Failed to fetch subscription info", e);
      }
    },

    // 常规登录
    async login() {
      const res = window.grecaptcha.getResponse();
      if (!res.length) {
        this.$vToastify.error("Please check the reCAPTCHA");
        return;
      }
      try {
        if (this.userName !== "" && this.password !== "") {
          const res = await api.logIn({
            username: this.userName,
            password: this.password.split(""),
            token: this.token,
            loginSource: this.isMobile ? 1 : 0,
          });
          console.log(res);
          this.$store.commit("saveUserInfo", res.data.data);
          if (res.data.data?.userId) {
            await this.fetchSubscriptionInfo(res.data.data.userId);
          }
          this.$router.push("/my-contributions");
        } else {
          this.$vToastify.error("Please fill all fields");
        }
      } catch (error) {
        console.log(error);
        if (error.data.message === "Unverified account ") {
          this.$router.push({
            name: "SignUpVerify",
            params: { userName: this.userName, password: this.password },
          });
        }
      }
    },

    // Google OAuth2 登录 - 跳转到Google页面
    googleLogin() {
      // 生成随机state参数用于安全验证
      const state = this.generateRandomString(32);
      // 生成随机nonce参数用于防止重放攻击
      const nonce = this.generateRandomString(32);

      // 将state和nonce存储到sessionStorage，回调时验证
      sessionStorage.setItem("google_oauth_state", state);
      sessionStorage.setItem("google_oauth_nonce", nonce);

      // 构建Google OAuth2 授权URL
      const googleAuthUrl = this.buildGoogleAuthUrl(state, nonce);

      console.log("Redirecting to Google OAuth2:", googleAuthUrl);

      // 跳转到Google登录页面
      window.location.href = googleAuthUrl;
    },

    // 构建Google OAuth2 授权URL
    buildGoogleAuthUrl(state, nonce) {
      const params = new URLSearchParams({
        client_id: this.googleClientId,
        redirect_uri: this.googleRedirectUri,
        response_type: "code",
        scope: this.googleScope,
        state: state,
        nonce: nonce, // 添加nonce参数
        access_type: "offline", // 获取refresh token
        prompt: "consent", // 强制显示同意屏幕
        include_granted_scopes: "true",
      });

      return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
    },

    // 处理Google回调
    handleGoogleCallback() {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");
      const state = urlParams.get("state");
      const error = urlParams.get("error");

      if (error) {
        console.error("Google OAuth error:", error);
        this.$vToastify.error("Google login failed: " + error);
        // 清理URL参数
        this.cleanUpUrl();
        return;
      }

      if (code && state) {
        // 验证state参数
        const storedState = sessionStorage.getItem("google_oauth_state");
        if (state !== storedState) {
          console.error("State mismatch - possible CSRF attack");
          this.$vToastify.error("Security validation failed");
          this.cleanUpUrl();
          return;
        }

        // 清理存储的state和nonce
        sessionStorage.removeItem("google_oauth_state");
        const storedNonce = sessionStorage.getItem("google_oauth_nonce");
        sessionStorage.removeItem("google_oauth_nonce");

        console.log("Google OAuth callback received:", { code, state });

        // 处理授权码，传递nonce到后端
        this.exchangeCodeForToken(code, storedNonce);

        // 清理URL参数
        this.cleanUpUrl();
      }
    },

    // 用授权码换取访问令牌
    async exchangeCodeForToken(code, nonce) {
      try {
        console.log("Exchanging code for token...");

        // 发送授权码到后端进行token交换
        const res = await api.googleLoginWeb({
          code,
          // nonce: nonce,
          createAccount: false,
          redirectUri: this.googleRedirectUri,
        });

        console.log("Google OAuth login successful");

        // 保存用户信息并跳转
        const userData = { ...res.data, isThirdPartyLogin: true };
        this.$store.commit("saveUserInfo", userData);
        if (userData?.userId) {
          await this.fetchSubscriptionInfo(userData.userId);
        }
        this.$router.push("/my-contributions");
      } catch (error) {
        console.error("Token exchange failed:", error);
        this.$vToastify.error("Google login failed. Please try again.");
      }
    },

    // 生成随机字符串用于state参数
    generateRandomString(length) {
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
      }
      return result;
    },

    // 清理URL参数
    cleanUpUrl() {
      const url = new URL(window.location);
      url.searchParams.delete("code");
      url.searchParams.delete("state");
      url.searchParams.delete("scope");
      url.searchParams.delete("error");
      window.history.replaceState({}, document.title, url.pathname + url.hash);
    },

    // 图形验证码
    getImage() {
      api
        .createImageCode()
        .then((res) => {
          this.token = res.headers.imagetoken;
          let el;
          el = this.$refs.logInImage;
          if (!el) {
            return;
          }
          el.src = `data:image/png;base64,${btoa(
            new Uint8Array(res.data).reduce(
              (data, byte) => `${data}${String.fromCharCode(byte)}`,
              ""
            )
          )}`;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    checkIfMobile() {
      if (this.isMobile) {
        this.$router.push({
          name: "Signup",
        });
      }
    },
  },
};
</script>

<style scoped>
.form-group__input .el-input-group >>> .el-input-group__append {
  width: 125px;
  height: 43px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.image-code {
  width: 125px;
  height: 43px;
}
</style>
